import { FaGithub, FaLinkedin, FaMapMarkerAlt } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import './footer.css';

export const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="site-footer">
            <div className="site-footer-inner">
                <div className="site-footer-identity">
                    <strong>Ahmed Magdy</strong>
                    <span><FaMapMarkerAlt aria-hidden="true" /> Saudi Arabia</span>
                </div>
                <nav aria-label="Footer social links">
                    <ul>
                        <li>
                            <a href="https://www.linkedin.com/in/ahmedmagdy" target="_blank" rel="noreferrer">
                                <FaLinkedin aria-hidden="true" /> LinkedIn
                            </a>
                        </li>
                        <li>
                            <a href="https://github.com/amgdy" target="_blank" rel="noreferrer">
                                <FaGithub aria-hidden="true" /> GitHub
                            </a>
                        </li>
                        <li>
                            <a href="https://x.com/amgdy" target="_blank" rel="noreferrer">
                                <FaXTwitter aria-hidden="true" /> X
                            </a>
                        </li>
                    </ul>
                </nav>
                <p>© <time dateTime={String(currentYear)}>{currentYear}</time> Ahmed Magdy. All rights reserved.</p>
            </div>
        </footer>
    );
};